import { fetchApi } from 'shared/functions';

export const getQuestionnaireAvailability = ({ qualificationId, userId }) => {
  return fetchApi(
    `/scopeuserqualification/should-display-qualifications/${userId}/${qualificationId}/`,
  ).then(response => response.json());
};

export const getQuestionnaireData = qualificationId => {
  return fetchApi(`/scopeuserqualification/get-questions/${qualificationId}/`).then(response =>
    response.json(),
  );
};

export const saveQuestionnaire = (items, qualificationId, userId) => {
  const params = {
    method: 'POST',
    body: JSON.stringify(items),
  };

  return fetchApi(
    `/scopeuserqualification/save-answers/${userId}/${qualificationId}/`,
    params,
  ).then(response => response.json());
};
